import { IOptions, IPNNVOption } from '../../../common/common.types'
import { GenericField } from '../../../utilities/object.util'
import { IInputRow } from '../ProcedureDynamic.component'

export interface IProcedureState {
  type: string
  inputRows: Array<IInputRow>
  assessedByOptions: IOptions
  complicationsOptions: IOptions
  responseOptions: IOptions
  authorizationOptions: IOptions
  rolePerformingOptions: IOptions
  isFirstVisit: boolean
  nemsisCodeOptions: INemsisSnomedLookup[]
}

export abstract class NemsisCodeError extends Error {
  constructor(message: string | undefined = undefined) {
    super(message)

    Object.setPrototypeOf(this, NemsisCodeError.prototype)
  }
}

export class NemsisCodeNotFoundError extends NemsisCodeError {
  constructor(message: string | undefined = undefined) {
    super(message)

    Object.setPrototypeOf(this, NemsisCodeNotFoundError.prototype)
  }
}

export class MoreThanOneNemsisCodeFoundError extends NemsisCodeError {
  constructor(message: string | undefined = undefined) {
    super(message)

    Object.setPrototypeOf(this, MoreThanOneNemsisCodeFoundError.prototype)
  }
}

export class NullNemsisCodeFoundError extends NemsisCodeError {
  constructor(message: string | undefined = undefined) {
    super(message)

    Object.setPrototypeOf(this, NullNemsisCodeFoundError.prototype)
  }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface INemsisProcedure {
  type: string | null
  nemsisCode: number | string | null
  [key: string]: any
  responsePNNV?: IPNNVOption | null
  rolePerformingPNNV?: IPNNVOption | null
  snomedId?: number | null
}

export interface INemsisSnomedLookup {
  procedure: string | null
  action: string | null
  filter1: string | null
  filter2: string | null
  filter3: string | null
  code: string | number | null
  snomedId: number | null
}

export interface INemsisLookupArguments {
  procedure: string
  action: string | null
  filter1: string | null
  filter2: string | null
  filter3: string | null
}

export interface INemsisFilterFields<T extends INemsisProcedure> {
  filter1Field: GenericField<T>
  filter2Field: GenericField<T>
  filter3Field: GenericField<T>
}

export interface INemsisLookupMetaArguments<T extends INemsisProcedure> extends INemsisFilterFields<T> {
  procedureState: T
  actionField: GenericField<T>
  nemsisCodeOptions: INemsisSnomedLookup[]
  includeSnomedId?: boolean
}
/* eslint-enable @typescript-eslint/no-explicit-any */
